export default "__VITE_ASSET__CAjc5Rfk__"